import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  Label,
  Row
} from 'reactstrap';
import {
  clearSuccessMessage,
  forgotPassword,
  forgotPasswordForm,
  setForgotPasswordConfirmationStatus
} from '../../store/actions';
// import logolight from "../../assets/images/only-switch-logo.png";
// import logodark from "../../assets/images/only-switch-logo.png";
import logolight from "../../assets/images/sixbit-logo-bg.jpg";
import logodark from "../../assets/images/sixbit-logo-bg.jpg";
import { Link, useNavigate } from 'react-router-dom';
import Message from '../../CommonData/Data/Message';

const Recover = (props) => {

  const { formforgot, confirmationStatus, forgotPasswordSuccessMsg } = props;
  const { errors } = formforgot || {};
  const naviagate = useNavigate();
  const credits = window.__ENV && window.__ENV.credits;
  useEffect(() => {
    props.setForgotPasswordConfirmationStatus('');
    props.forgotPasswordForm({
      errors: {}
    })
    props.clearSuccessMessage();
  }, []);

  const validateOnChange = (event) => {
    const { name, value } = event.target;
    let result = {};
    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      result = {
        isValid: emailRegex.test(value),
        message: 'Enter valid email',

      }
    }
    props.forgotPasswordForm({
      ...props.formforgot,
      [name]: value,
      errors: {
        [name]: result.isValid ? null : result.message,
      }
    })
  };

  //focus down while press enter 
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSubmit(e);
    }
  }
  const onSubmit = (e) => {
    e.preventDefault();
    const { email, errors } = formforgot;
    let currentErrors = {};
    if (!email) {
      currentErrors.email = 'Email is required'
    }
    if (errors && errors.email) {
      currentErrors.email = 'Enter valid email'
    }
    props.forgotPasswordForm({
      ...formforgot,
      errors: currentErrors
    });
    if (Object.keys(currentErrors).length === 0) {
      props.forgotPassword(props.formforgot.email);
    }
  };
  const handleLoginPage = () => {
    naviagate("/")
  }
  return (
    <div className="page-content">
      <React.Fragment>
        {/* <div className="bg-pattern" style={{ height: "100vh" }}> */}
        <div className="bg-overlay"></div>
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card className='mt-5'>
                  <CardBody className="p-4">
                    {/* <div className=""> */}
                    <div className="text-center">
                      <Link to="/" className="">
                        <img
                          src={logodark}
                          alt=""
                          height="80"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="80"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">RESET PASSWORD</h4>
                    <form className="form-horizontal" action="#">
                      <Row className='mt-4'>
                        {forgotPasswordSuccessMsg && (
                          <Message
                            type="success"
                            defaultMessage={forgotPasswordSuccessMsg}
                            baseClassName="alert"
                          />
                        )}
                        <Col md={12}>
                          <div className="mt-2">
                            <Label>Email</Label><span className="text-danger">*</span>
                            <InputGroup>
                              <Input
                                autoFocus
                                type="email"
                                name="email"
                                id="email"
                                className={errors && errors.email ? "form-control border-end-0" : " border-end-0 form-control border-secondary"}
                                placeholder="Enter email"
                                onChange={validateOnChange}
                                onKeyPress={handleKeyPress}
                                invalid={errors && errors.email}
                              />
                              <Button
                                color='white'
                                className={errors && errors.email ? "border-danger border-start-0 rounded-end" : 'border-dark border-start-0 rounded-end'}
                                disabled
                              ><i class="fas fa-envelope text-dark"></i>
                              </Button>
                              <FormFeedback>{errors && errors.email}</FormFeedback>
                            </InputGroup>
                          </div>
                          <div className="d-grid mt-4">
                            <Button
                              color="primary"
                              onClick={onSubmit}
                              disabled={props.forgotPasswordPending}
                            >
                              {props.forgotPasswordPending ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Loading...
                                </>
                              ) : (
                                "Reset password"
                              )}
                            </Button>
                            <Button
                              color="link"
                              className='text-decoration-underline text-info mt-4'
                              onClick={handleLoginPage}
                            >Go to login page
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                    {/* </div> */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <div className="position-absolute bottom-0 start-50 translate-middle-x mt-5 text-center">
            <p className="text-white-50">
              © {new Date().getFullYear()} {credits}.
            </p>
          </div>
        </div>
        {/* </div> */}
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formforgot: state.login.formforgot,
  confirmationStatus: state.login.confirmationStatus,
  forgotPasswordSuccessMsg: state.login.forgotPasswordSuccessMsg,
  forgotPasswordPending: state.login.forgotPasswordPending,
});

const mapDispatchToProps = (dispatch) => ({
  forgotPasswordForm: (formforgot) => dispatch(forgotPasswordForm(formforgot)),
  forgotPassword: (email) => dispatch(forgotPassword(email)),
  clearSuccessMessage: () => dispatch(clearSuccessMessage()),
  setForgotPasswordConfirmationStatus: (status) => dispatch(setForgotPasswordConfirmationStatus(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(Recover);




